module.exports = __webpack_public_path__ + "static/media/devIcon.95bf52f8.jpg";